<template>
	<div id="Container" >
		<nav-bar />
		<div class="box">
			<el-carousel height="400px">
				<el-carousel-item v-for="(item, index) in dataList" :key="index">
					<img class="icon" :src="item.filePath" >
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="body">
			<div class="tips">
				<div>今天是 {{ date }}</div>
				<div class="icon">
					<img src="@/assets/image/email.jpg">
					<span class="more" @click="more(4)">城投信箱</span>
					<span> | </span>
					<img src="@/assets/image/pos.jpg">
					<span class="more" @click="more(5)">路线指引</span>
				</div>
			</div>

			<div class="content_box">
				<div style="width: 49%;">
					<div class="felx1" style="margin-bottom: 8px;">
						<img src="@/assets/image/trends.jpg">
						<span class="more" @click="more(1)">更多</span>
					</div>

					<div>
						<a v-for="(item, index) in newsData" :key="index"
							:class="index == 0 ? 'cnet trends_box' : 'trends_box'"
							@click="item.webLink ? 1 : itemClick(0, item)" :href="item.webLink" target="_blank">
							<div class="left">
								<img :src="item.filePath" v-if="index == 0" class="img1">
								<img src="@/assets/image/arrow.png" class="img2" v-else>
							</div>
							<div :class="index == 0 ? 'right' : 'right_info'">
								<div v-if="index == 0">
									<div class="more more_ove flot">{{ item.title }}</div>
									<div class="tips_info more" v-text="item.textContent"> </div><!--{{ item.textContent }}-->
									<!-- <div class="more" style="text-align: right;">详细></div> -->
								</div>
								<div v-else class="more  felx1">
									<div class="more_ove1">{{ item.title }}</div>
									<div>{{ item.releaseTime.split(' ')[0] }}</div>
								</div>
							</div>
						</a>

					</div>
				</div>

				<div class="felx">
					<div style="width: 100%;">
						<div>
							<div class="felx1" style="margin-bottom: 8px;">
								<img src="@/assets/image/open.png">
								<span class="more" @click="more(2)">更多</span>
							</div>

							<div>
								<a v-for="(item, index) in infoData" :key="index" class="box_gk"
									@click="item.webLink ? 1 : itemClick(1, item)" :href="item.webLink" target="_blank">
									<img :src="item.filePath" v-if="item.filePath" class="zp">
									<img src="../assets/image/blank.png" v-else class="zp">

									<!-- <img src="@/assets/image/zp.jpg" class="zp"> -->
									<div class="box1">
										<div class="more more_ove flot">{{ item.title }}</div>
										<div class="info more">{{ item.textContent }}</div>
										<!-- <div class="more" style="text-align: right;">详细></div> -->
									</div>
								</a>
							</div>
						</div>
						<div style="margin-top: 20px;">
							<div class="felx1" style="margin-bottom: 8px;">
								<img src="@/assets/image/img11.jpg">
								<span class="more" @click="more(3)">更多</span>
							</div>
							<div>
								<a v-for="(item, index) in infoType" :key="index" class="box_gk"
									@click="item.webLink ? 1 : itemClick(2, item)" :href="item.webLink" target="_blank">
									<img :src="item.filePath" v-if="item.filePath" class="zp">
									<img src="../assets/image/blank.png" v-else class="zp">
									<!-- <img src="@/assets/image/zp.jpg" class="zp"> -->
									<div class="box1">
										<div class="more more_ove flot">{{ item.title }}</div>
										<div class="info more">{{ item.textContent }}</div>
										<!-- <div class="more" style="text-align: right;">详细></div> -->
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<bot-bar />
	</div>
</template>

<script>
import BotBar from '../components/BotBar'
import NavBar from '../components/NavBar'
import {
	richtexts,
	// richtextDetail
} from '@/api/apis'

export default {
	components: {
		NavBar,
		BotBar
	},
	name: 'Home',
	data() {
		return {
			dataList: [
				require('../assets/image/banner1.jpg'),
				require('../assets/image/banner2.jpg'),
				require('../assets/image/banner3.jpg'),
				require('../assets/image/banner4.jpg'),
			],
			date: '',
			newsData: [],
			infoData: [],
			infoType: [],
			flag1: '',
			flag2: '',
			flag3: '',
			flag4: '',
			flag5: '',
		}
	},

	created() {
		this.date = this.newDate()
		this.getBanner()
		this.getData()
		this.getInfo()
		this.getType()
	},

	mounted() {

	},
	methods: {
		// getCes(){
		// 	richtextDetail(10).then(res => {
		// 		console.log('dataDetail', res.data)
		// 		if (res.code == 1) {
		// 			this.dataDetail = res.data
		// 		}
		// 	})
		// },
		newDate() {
			var date = new Date()
			var y = date.getFullYear()
			var m = date.getMonth() + 1
			var weekDays = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
			var weekNum = date.getDay(); //获取星期几，0表示星期日，1表示星期一，以此类推
			m = m < 10 ? '0' + m : m
			var d = date.getDate()
			d = d < 10 ? '0' + d : d
			return y + ' 年' + m + ' 月' + d + ' 日  ' + weekDays[weekNum]
		},
		getBanner() {
			let params = {
				type: 14,
				pageNum: 1,
				pageSize: 10,
				searchStatus: 1
			}
			richtexts(params).then(res => {
				console.log('banner', res.data)
				if (res.code == 1) {
					this.dataList = res.data.records
				}
			})
		},
		getData() {

			let params = {
				pageNum: 1,
				pageSize: 7,
				type: 1,
				searchStatus: 1
			}
			richtexts(params).then(res => {
				console.log('res1', res.data.records)
				if (res.code == 1) {
					this.newsData = res.data.records
				}
			})
		},
		getInfo() {
			let params = {
				pageNum: 1,
				pageSize: 2,
				type: 2,
				searchStatus: 1
			}
			richtexts(params).then(res => {
				console.log('res2', res.data.records)
				if (res.code == 1) {
					this.infoData = res.data.records
				}
			})
		},
		getType() {
			let params = {
				pageNum: 1,
				pageSize: 1,
				type: 3,
				searchStatus: 1
			}
			richtexts(params).then(res => {
				console.log('res3', res.data.records)
				if (res.code == 1) {
					this.infoType = res.data.records
				}
			})
		},
		itemClick(homeIndex, item) {
			const that = this
			switch (homeIndex) {
				case 0:
					that.$router.push({
						name: 'richtextDetail',
						query: {
							richId: item.id,
							titleTree: JSON.stringify([{
								title: '首页',
								path: 'Home'
							},
							{
								title: '新闻在线',
								path: 'news'
							},
							{
								title: '集团动态',
								path: 'news',
								index: 0
							}
							])
						}
					})
					break;
				case 1:
					that.$router.push({
						name: 'richtextDetail',
						query: {
							richId: item.id,
							titleTree:JSON.stringify( [{
								title: '首页',
								path: 'Home'
							},
							{
								title: '信息公开',
								path: '',
								index: 0
							}
							])
						}
					})
					break;
				case 2:
					that.$router.push({
						name: 'richtextDetail',
						query: {
							richId: item.id,
							titleTree: JSON.stringify([{
								title: '首页',
								path: 'Home'
							},
							{
								title: '专题栏目',
								path: '',
								index: 0
							}
							])
						}
					})
					break;
				default:
					break;
			}


		},
		more(index) {
			let child = JSON.parse(localStorage.getItem("childen"))
			let cx = child.filter(item => item.title == "新闻在线" || item.title == "联系我们" || item.title == "党群工作")
			let other = JSON.parse(localStorage.getItem("other_childen"))
			cx.push({
				title: '信息公告',
				children: other
			})
			console.log("查询结果", cx)

			cx.forEach(item => {
				if (item.title == '新闻在线' && item.children.length > 0) {
					this.flag1 = item.children.findIndex(item => item.title === "集团动态")
				}
				if (item.title == '信息公告' && item.children.length > 0) {
					this.flag2 = item.children.findIndex(item => item.title === "信息公告")
					this.flag3 = item.children.findIndex(item => item.title === "专题栏目")
				}
				if (item.title == '党群工作' && item.children.length > 0) {
					this.flag4 = item.children.findIndex(item => item.title === "城投信箱")
				}
				if (item.title == '联系我们' && item.children.length > 0) {
					this.flag5 = item.children.findIndex(item => item.title === "路线指引")
				}
			});

			if (index == 1) {
				if (this.flag1 != -1) {
					this.$router.push({
						name: 'news',
						query: {
							index: this.flag1.toString(),
						}
					})
				}

				console.log("flag1", this.flag1)
			}
			if (index == 2) {
				if (this.flag2 != -1) {
					this.$router.push({
						name: 'message',
						query: {
							index: this.flag2.toString(),
						}
					})
				}
				console.log("flag2", this.flag2)

			}
			if (index == 3) {
				if (this.flag3 != -1) {
					this.$router.push({
						name: 'message',
						query: {
							index: this.flag3.toString(),
						}
					})
				}
				console.log("flag3", this.flag3)

			}

			if (index == 4) {
				if (this.flag4 != -1) {
					this.$router.push({
						name: 'political',
						query: {
							index: this.flag4.toString()
						}
					})
				}
				console.log("flag4", this.flag4)

			}

			if (index == 5) {
				if (this.flag5 != -1) {
					this.$router.push({
						name: 'callus',
						query: {
							index: this.flag5.toString(),
						}
					})
				}
				console.log("flag5", this.flag5)

			}
		},

	}
}
</script>

<style lang="scss" scoped>
::v-deep .el-carousel__arrow {
	background-color: #0000008f !important;
}

#Container {

	.box {
		width: 1200px;
		margin: 0 auto;

		img {
			width: 100%;
			height: 400px;
		}
	}

	.body {
		width: 100%;
		background: url('../assets/image/bg001.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding-bottom: 20px;

		.tips {
			width: 1100px;
			height: 35px;
			margin: 0 auto;
			border-bottom: 1px solid #273c67;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 13px;
			line-height: 35px;
			// font-family: '微软雅黑';
			color: #444;

			.icon {
				display: flex;
				justify-content: center;
				align-items: center;

				span {
					margin: 0 3px;
				}
			}
		}

		.content_box {
			margin: 0 auto;
			display: flex;
			// align-items: center;
			justify-content: space-between;
			width: 1100px;

			.trends_box {
				display: flex;
				line-height: 35px;
				// justify-content: center;
				align-items: center;
				// margin-bottom: 8px;


				.left {

					.img1 {
						width: 150px;
						height: 120px;
						border-radius: 4px;
					}
				}

				.right {
					margin-left: 20px;
					// width: 285px;
				}

				.right_info {
					margin-left: 5px;
					width: 100%;
				}
			}

		}

	}

	.cnet {
		// justify-content: space-between;
		align-items: normal !important;
		// margin-bottom: 20px;
	}

	.felx {
		display: flex;
		// align-items: center;
		justify-content: space-between;
		width: 43%;
	}

	.felx1 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 96%;	
	}

	.margin {
		margin-left: 6%;
	}

	.more_ove {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		// flex: 1;
		// margin-right: 10px;
		font-size: 14px;
		text-align: left;
		width: 300px;

	}

	.more_ove1 {
		overflow: hidden;
		font-size: 14px;
		width: 76%;
		text-align: left;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.flot {
		font-weight: bold;
		text-align: left;
	}

	.tips_info {
		// height: 64px;
		text-align: left;
		line-height: 25px !important;
		font-size: 13px;
		// color: rgb(85, 85, 85);
		// font-family: 微软雅黑;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 3;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		width: 95%
	}

	.info {
		text-align: left;
		line-height: 20px;
		font-size: 13px;
		// font-family: 微软雅黑;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		height: 60px;
		width: 340px;
	}

	.zp {
		width: 100px;
		height: 80px;
		border-radius: 4px;
	}

	.box_gk {
		display: flex;
		// align-items: center;
		width: 100%;
		height: 85px;
		margin-bottom: 10px;

		.box1 {
			margin-left: 20px;
			/* height: 90px; */
			// width: 325px;
		}
	}

	.more {
		line-height: 30px;
	}

}
</style>